import React from "react";
import { createRoot } from "react-dom/client";
import { SiteTheme, FilterData } from "../../types/types";
import RecipeFilter from "./RecipeFilter";

let filterData : FilterData;

const RecipeFilterContainer = () => {
    const dataElement = document.getElementById("recipe-filter-items");
    if (dataElement) {
        const data = JSON.parse(dataElement.textContent || "[]");
        filterData = data;
    }

    const container = document.querySelector(
        "#recipe-filter",
    ) as HTMLElement;
    const siteTheme = document
        .querySelector("body")
        ?.getAttribute("data-site") as SiteTheme;

    if (container) {
        createRoot(container).render(
            <RecipeFilter
                filterData={filterData}
                siteTheme={siteTheme}
                searchPageUrl="/recept/"
            />,
        );
    }
};

export default RecipeFilterContainer;
